import { defineComponent as _defineComponent } from 'vue'
import BCXDottedBox from '@/components/molecules/BCXDottedBox.vue';
import Marvin from '@/components/svg/marvin/marvin_idea_2.svg?inline';
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';
import useUser from '@/mixins/useUser';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectNewProjectLimitReached',
  setup(__props) {

const { tUserFallback: t } = useUser('self');

return { __sfc: true,t, BCXDottedBox, Marvin, BCXMarkdown }
}

})